import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'custom-number-input-type',
  templateUrl: './custom-number-input-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomNumberInputTypeComponent extends FieldType<FieldTypeConfig> {
  @ViewChild('customNumberInput', { static: true }) input: ElementRef<HTMLInputElement>;
  textInputFieldTypes = ['text'];

  onPopulate(field: FormlyFieldConfig) {
    if (!field.props?.type) {
      field.props.type = 'text';
      return;
    }

    if (!this.textInputFieldTypes.includes(field.props.type)) {
      throw new Error(
        'parameter <templateOptions.type> is not valid for TextInputFieldComponent, only text, email, password and tel are possible values'
      );
    }
  }
  inputValidator(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
      const inputElement: HTMLInputElement = this.input.nativeElement as HTMLInputElement;
      inputElement.dispatchEvent(new InputEvent('input'));
    }
  }
}
